import React, {useContext, useEffect, useState} from "react";
import {Button, Dropdown, Space, Table} from "antd";
import {DeleteOutlined, DownOutlined, EditOutlined} from "@ant-design/icons";
import {
    AssetAttributeType,
    useDeleteAssetAttributesMutation,
    useGetAssetAttributesQuery
} from "../../../../../api/assetApi";
import {ModalConfirmContext} from "../../../../../providers/ModalConfirmProvider";

type LogicAttributesProps = {
    id: number
    onClick: (item: any) => void
    editAttribute: (item: AssetAttributeType) => void
}

const LogicAttributes = ({onClick, editAttribute, id}: LogicAttributesProps) => {
    const {showModal} = useContext(ModalConfirmContext);
    const [dataSource, setDataSource] = useState<DataSourceType[]>([]);

    const {data: assetAttributes, isLoading, refetch: refetchAssetAttribute} = useGetAssetAttributesQuery({id});
    const [deleteAttribute, result] = useDeleteAssetAttributesMutation();
    const {isLoading: isLoadingDeleted, isSuccess: isSuccessDeleted} = result;

    useEffect(() => {
        if (assetAttributes) {
            const data = assetAttributes.map(attr => {
                const {name, id: key} = attr;
                return {key: key as number, name};
            });

            setDataSource(data);
        }
    }, [assetAttributes]);

    useEffect(() => {
        if (isSuccessDeleted) refetchAssetAttribute();
    }, [isSuccessDeleted]);

    const columns = [
        {
            dataIndex: 'name',
            key: 'name',
        },
        {
            dataIndex: 'actions',
            key: 'actions',
            render: (_: any, info: DataSourceType) => (
                <div style={{display: "flex", justifyContent: "flex-end"}}>
                    <Button type="link" onClick={() => {
                        editAttribute(assetAttributes!.find(attr => attr.id === info.key) as AssetAttributeType);
                    }} size="small">
                        <EditOutlined/>
                    </Button>
                    <Button type="link" onClick={() => {
                        showModal("delete this attribute", () => deleteAttribute([info.key]));
                    }} size="small">
                        <DeleteOutlined/>
                    </Button>
                </div>
            ),
        },
    ];

    return (
        <>
            <div style={{marginBottom: 16}}>
                <Table loading={isLoading || isLoadingDeleted} pagination={false} showHeader={false}
                       dataSource={dataSource} columns={columns}/>
            </div>

            <Dropdown menu={{items, onClick}}>
                <Button>
                    <Space>
                        Add Attribute <DownOutlined/>
                    </Space>
                </Button>
            </Dropdown>
        </>
    );
};

export default LogicAttributes;

type DataSourceType = { key: number, name: string }

const items: { label: string, key: string }[] = [
    {
        label: "Asset",
        key: "5",
    },
    {
        label: "Boolean",
        key: "2",
    },
    {
        label: "Number",
        key: "3",
    },
    {
        label: "String",
        key: "4",
    },
];

